const ALERT = `ALERT@${__filename}`;

export function setAlert(message) {
  return {
    type: ALERT,
    toastMessages: {
      alert: message,
    },
  };
}

export function setErrorReason(reason: { message: string }) {
  return setAlert(reason.message);
}

export function reducer(state = {}, action) {
  switch (action.type) {
    case ALERT:
      return {
        ...state,
        toastMessages: action.toastMessages,
      };
    default:
      return state;
  }
}
